import React from 'react'

import PropTypes from 'prop-types';

import './Indicator.css'

import {FaChartLine} from 'react-icons/fa'


import {Indicator as IndClass} from '../../../js/IndicatorsPool';
import PopupStore, { POPUPS_IDS } from '../../../stores/PopupStore';


function Indicator({data, value}) {
  if(value === undefined) value = "ERROR"


  function showGraphPopup() {
    PopupStore.open(POPUPS_IDS.IND_HISTORY, data)
  }

  return (
    <div className={"indicator" + (isNaN(value) ? " error" : "")} title={data.id} >
      <div className="indicator-top">
        <div className="indicator-title" dangerouslySetInnerHTML={{__html: data.title}} />
        <div className="indicator-value">
          {value}
          <span className="indicator-unit" dangerouslySetInnerHTML={{__html: data.unit}} />
        </div>
      </div>

      <div className="indicator-description">
        <span dangerouslySetInnerHTML={{__html: data.description}} />
        <button onClick={showGraphPopup} className="show-indicator-history" >
          <FaChartLine />
        </button>
      </div>
    </div>
  )
}

// NOTE : je teste pour voir si ca permettait d'autocomplete les champs mais non...
Indicator.propTypes = {
  data: PropTypes.instanceOf(IndClass)
};
export default Indicator
